/** @jsxImportSource @emotion/react */
import { useLingui } from '@lingui/react/macro';
import { HelpCircle, Info, Settings } from 'lucide-react';
import { Pages } from 'modules/navigation/domain/enums/pages';
import React from 'react';
import type { DivProps } from 'typings';
import MenuItem from '../menu-item';
import * as S from './styles';

interface IProps extends DivProps {}

const MenuTechnical = React.memo(function MenuTechnicalIcon(props: IProps) {
  const { ...rest } = props;
  const { t } = useLingui();

  return (
    <S.MainBlock {...rest}>
      <MenuItem to={Pages.SETTINGS.INDEX} icon={<Settings size={16} />} label={t`Настройки`} />
      <MenuItem to={Pages.ABOUT} icon={<Info size={16} />} label={t`О приложении`} />
      <MenuItem to={'/help'} icon={<HelpCircle size={16} />} label={t`Помощь`} disabled tooltip={t`В разработке`} />
    </S.MainBlock>
  );
});

export default MenuTechnical;
